<template>
  <div>
    <section-page
      title="Campaign Cost Templates"
      description="This will allow you to create campaign cost template that can be reused when working with campaigns."
    >
      <template v-slot:right>
        <button-outlined class="ml-50" icon-left="plus" @click="createCampaignCostTemplates">
          New Cost Template
        </button-outlined>
      </template>

      <app-loading-section
        :count="costTemplates.length"
        :loading="isTableLoading"
        heading="You don't have any campaign cost template. Why don't you make one."
      >
        <table-default
          :table-data="costTemplates"
          default-sort="label"
        >
          <b-table-column label="Label" field="label" sortable v-slot="props">
            {{ props.row.label }}
          </b-table-column>

          <b-table-column label="Cost" field="cost" sortable v-slot="props">
            {{ utils.formatCurrency(props.row.amount) }}
          </b-table-column>

          <b-table-column label="Description" field="description" v-slot="props" width="400">
            <div v-html="utils.truncateString(props.row.description, 100)"></div>
          </b-table-column>

          <b-table-column cell-class="action_cell" width="120" v-slot="props">
            <button-link @click="editCampaignCostTemplates(props.row)">Manage</button-link>
          </b-table-column>
        </table-default>
      </app-loading-section>
    </section-page>

    <modal-container>
      <modal-crud-form
        ref="campaignCostModal"
        title="Campaign Cost"
        form-component="campaign-cost-template-form"
        @saved="getCampaignCostTemplates"
      />
    </modal-container>
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../services/utils";

export default {
  name: "CampaignSettingTab",
  computed: {
    utils() {
      return utils
    }
  },
  data() {
    return {
      isTableLoading: false,
      costTemplates: [],
    }
  },
  mounted() {
    this.getCampaignCostTemplates()
  },
  methods: {
    getCampaignCostTemplates() {
      this.isTableLoading = true
      return api.campaignCostTemplate.all()
        .then(res => {
          this.costTemplates = res.data
        })
        .finally(() => this.isTableLoading = false)
    },
    createCampaignCostTemplates() {
      this.$refs.campaignCostModal.open()
    },
    editCampaignCostTemplates(costTemplate) {
      this.$refs.campaignCostModal.open(costTemplate)
    },
  }
};
</script>

<style scoped lang="scss">

</style>
